import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Cookie from "js-cookie";
import Element from "element-ui";
import titleBox from "./components/titleBox.vue";
import noticePage from "./components/noticePage.vue";
import pagination from "./components/pagination.vue";
import menuPage from "./components/menuPage.vue";

import "element-ui/lib/theme-chalk/index.css";

import "@/styles/index.scss"; // global css
Vue.config.productionTip = false;
Vue.component("titleBox", titleBox);
Vue.component("noticePage", noticePage);
Vue.component("pagination", pagination);
Vue.component("menuPage", menuPage);

Vue.use(Element, {
    size: Cookie.get("size") || "medium",
});
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
